import {
  PLAYERS,
  TOKENS_PER_PLAYER,
  TOKEN_STATUS,
} from "./gameConstants";


// ============================================
// CREATE ALL 16 TOKENS
// ============================================

export function createInitialTokens() {

  const tokens = [];

  PLAYERS.forEach((color) => {

    for (
      let i = 0;
      i < TOKENS_PER_PLAYER;
      i++
    ) {

      tokens.push({
        id: `${color}-${i + 1}`,

        color,

        tokenNumber: i + 1,

        status: TOKEN_STATUS.HOME,

        // -1 means token is inside home
        step: -1,
      });

    }

  });

  return tokens;
}